"use client";

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { SessionStorageConstants } from "@thriwe-2-0/thriwe-ui-utils";

const getTranslations = async (lang: string) => {
  const projectCode =
    process.env.NEXT_PUBLIC_PROJECT_CODE_ASSET || "marketplace";

  try {
    const translationModule = await import(`./locales/${projectCode}/${lang}`);
    return translationModule.default;
  } catch (error) {
    console.error(
      `Error loading translations for ${projectCode}/${lang}:`,
      error
    );
    return {};
  }
};

export const initializeI18n = async () => {
  const lng =
    typeof window !== "undefined"
      ? localStorage.getItem(SessionStorageConstants.LANGUAGE) || "en"
      : "en";

  const resources = {
    en: { translation: await getTranslations("en") },
    ksa: { translation: await getTranslations("ar") },
  };
  // switch (lng) {
  //   case "ksa":
  //     moment.locale("ar-sa");
  //     break;
  //   default:
  //     moment.locale("en");
  // }

  await i18n.use(initReactI18next).init({
    resources,
    lng,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
      format: (value, format, lng) => {
        if (format === "uppercase") return value.toUpperCase();
        if (format === "lowercase") return value.toLowerCase();
        if (format === "capitalize")
          return value
            .split(" ")
            .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
        return value;
      },
    },
  });
  return i18n;
};

export default i18n;
